export const formatPercentWithSign = (number, precision = 1) => `${number > 0 ? "+" : ""}${(number * 100).toFixed(precision)}%`;
